export default __webpack_public_path__ + "e9570cd15dfb0bcb4c81503dee23e5e3.woff";